import React from 'react';

import { SVGComponentProps } from './svg.types';

const LessonSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M1.33331 2H5.33331C6.04056 2 6.71883 2.28095 7.21893 2.78105C7.71903 3.28115 7.99998 3.95942 7.99998 4.66667V14C7.99998 13.4696 7.78927 12.9609 7.41419 12.5858C7.03912 12.2107 6.53041 12 5.99998 12H1.33331V2Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 2H10.6667C9.95942 2 9.28115 2.28095 8.78105 2.78105C8.28095 3.28115 8 3.95942 8 4.66667V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H14.6667V2Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default LessonSVG;
